import { isLarge } from "./helpers";

(function ($) {
  "use strict";

  $(window).on("load", function () {
    backToTopLink();
    animateScrollTo();
    longFormDoc();
  });
})(jQuery);

function trimLeadingTrailingSlashes(path) {
  return path.replace(/^\//, "").replace(/\/$/, "");
}

/**
 * Overrides default browser behaviour when navigating to a hash on the current page.
 * Animates the scroll to the target element.
 *
 * Applies site-wide, and one of the primary uses is on LongFormDocument pages for jumping between
 * sections via the sticky 'Index' sidebar
 *
 * See also:
 * `accordions.js` for animating scroll to an accordion on page load via URL hash
 */
function animateScrollTo() {
  $("#main-page-content").on("click", "a[href*='#']", function (e) {
    let target;
    const $linkElement = $(this);
    const linkHash = $linkElement.prop("hash");
    // Height (px) of sticky header in it's small state
    const headerHeight = 66;

    const linkPathName =
      trimLeadingTrailingSlashes($(this).prop("pathname")) || "";
    const currentPathName = trimLeadingTrailingSlashes(location.pathname);

    const hasHash = !!linkHash;
    const isCurrentPath =
      linkPathName === "" || linkPathName === currentPathName;
    const isCurrentHostname = $(this).prop("hostname") === location.hostname;

    /**
     * Check if the link targets a hash on the current page, for example:
     *   <a href='#section-two`></a>
     *   <a href='current/page/path#section-two'></a>
     */
    if (isCurrentHostname && isCurrentPath && hasHash) {
      e.preventDefault();
      // Look for an element with a matching ID
      target = $(linkHash);

      if (!target.length) {
        // Check for accordion landmarks using the `name` attribute - See `ElementAccordion.ss`
        target = $("[name='" + linkHash.slice(1) + "']");
      }
    }

    if (!(target && target.length)) {
      return;
    }

    // If the target is within an accordion, make sure it's open
    if ($(target).closest(".accordion").length) {
      const accordion = $(target).closest(".accordion");
      if (accordion.length) {
        accordion.openAccordion($(target).closest(".accordion"));
      }
    }

    target.attr("tabindex", "-1");
    const scrollDepth = target.offset().top - headerHeight - 20;

    $("html, body").animate({ scrollTop: scrollDepth }, 600, function () {
      target.focus();
      // Temporarily remove ID attribute from the target to prevent browser jumping to it
      const targetId = target.attr("id");
      target.attr("id", "");

      // Update the URL with the new hash
      if (history.pushState) {
        history.pushState(
          { clickedScroll: true },
          null,
          location.origin + location.pathname + linkHash
        );
      } else {
        window.location.hash = linkHash;
      }

      // Reinstate target ID attribute
      target.attr("id", targetId);

      if ($linkElement.closest("#lf-doc-nav").length) {
        updateLongFormNavActive($linkElement);
      }
    });

    return false;
  });
}

export function stickyBackToTop(scrollOffset, screenHeight, footerOffset) {
  if (scrollOffset > screenHeight) {
    $("#back-to-top .back-to-top__button").fadeIn(200);
  } else {
    $("#back-to-top .back-to-top__button").fadeOut(200);
  }

  if (scrollOffset + screenHeight >= footerOffset) {
    $("#back-to-top").css({
      position: "absolute",
      bottom: "0",
    });
  } else {
    $("#back-to-top").css({
      position: "",
      bottom: "",
    });
  }
}

function backToTopLink() {
  $("#back-to-top .back-to-top__button").on("click", function (e) {
    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600
    );

    $("#main-page-content").focus();
  });
}

var longFormNavOffset = 88;
var longFormNavScrollTicking = false;

function longFormDoc() {
  if ($("#lf-doc-nav").length > 0) {
    updateLongFormNavActive();

    $(window)
      .on("scroll.lfdocspy", queueLongFormNavActiveUpdate)
      .on("resize.lfdocspy", updateLongFormNavActive);
  }

  // tablet / mobile accordion of scrolling nav
  toggleLFDocNavInit();

  var resizeTimer;
  $(window).on("resize.lfdoc", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      toggleLFDocNavInit();
    }, 100);
  });
}

function queueLongFormNavActiveUpdate() {
  if (longFormNavScrollTicking) {
    return;
  }

  longFormNavScrollTicking = true;

  window.requestAnimationFrame(function () {
    longFormNavScrollTicking = false;
    updateLongFormNavActive();
  });
}

function getLongFormNavScrollPosition() {
  return $(window).scrollTop() + longFormNavOffset;
}

function getLongFormNavTarget($link) {
  var hash = $link.prop("hash");

  if (!hash) {
    return $();
  }

  return $(hash);
}

function getLongFormNavTargetTop($link) {
  var $target = getLongFormNavTarget($link);

  if (!$target.length || !$target.is(":visible")) {
    return null;
  }

  return $target.offset().top;
}

function findActiveLongFormNavLinks() {
  var scrollPos = getLongFormNavScrollPosition();
  var $activeSectionLink = null;
  var $activeSubsectionLink = null;

  $("#lf-doc-nav .lf-nav__section").each(function () {
    var $section = $(this);
    var $sectionLink = $section.children(".lf-nav__link--section").first();
    var sectionTop = getLongFormNavTargetTop($sectionLink);

    if (sectionTop === null || scrollPos < sectionTop) {
      return;
    }

    $activeSectionLink = $sectionLink;
    $activeSubsectionLink = null;

    $section.find(".lf-nav__link--subsection").each(function () {
      var $subsectionLink = $(this);
      var subsectionTop = getLongFormNavTargetTop($subsectionLink);

      if (subsectionTop !== null && scrollPos >= subsectionTop) {
        $activeSubsectionLink = $subsectionLink;
      }
    });
  });

  // When scrolled above the first heading, default to the first section so the
  // index always highlights a section and reveals its secondary list.
  if (!$activeSectionLink) {
    $activeSectionLink = $("#lf-doc-nav .lf-nav__section")
      .first()
      .children(".lf-nav__link--section")
      .first();

    if (!$activeSectionLink.length) {
      $activeSectionLink = null;
    }
  }

  return {
    $sectionLink: $activeSectionLink,
    $subsectionLink: $activeSubsectionLink,
  };
}

function updateLongFormNavActive($clickedLink) {
  var $nav = $("#lf-doc-nav");

  if (!$nav.length) {
    return;
  }

  if ($clickedLink && $clickedLink.length) {
    var $clickedSection = $clickedLink.closest(".lf-nav__section");
    var $sectionLink = $clickedSection
      .children(".lf-nav__link--section")
      .first();
    var $subsectionLink = $clickedLink.hasClass("lf-nav__link--subsection")
      ? $clickedLink
      : null;

    setLongFormNavActive($sectionLink, $subsectionLink);
    return;
  }

  var activeLinks = findActiveLongFormNavLinks();
  setLongFormNavActive(
    activeLinks.$sectionLink,
    activeLinks.$subsectionLink
  );
}

function setLongFormNavActive($sectionLink, $subsectionLink) {
  var $nav = $("#lf-doc-nav");

  $nav.find(".lf-nav__link, .lf-nav__section, .lf-nav__subsection").removeClass(
    "active"
  );

  if (!$sectionLink || !$sectionLink.length) {
    return;
  }

  var $section = $sectionLink.closest(".lf-nav__section");

  $section.addClass("active");
  $sectionLink.addClass("active");

  if ($subsectionLink && $subsectionLink.length) {
    $subsectionLink.addClass("active");
    $subsectionLink.parent(".lf-nav__subsection").addClass("active");
  }
}

function toggleLFDocNavInit() {
  var headingLFDoc = $("#lf-doc-nav > h2");

  if (!isLarge()) {
    // enable section nav toggle
    if (!headingLFDoc.children("button").length > 0) {
      headingLFDoc.wrapInner(
        '<button class="button button--primary lf-doc-nav__toggle" aria-controls="lf-doc-nav-list" aria-expanded="false" title="Toggle section navigation open or closed"></button>'
      );

      headingLFDoc.children("button").on("click", function (e) {
        if (headingLFDoc.hasClass("open")) {
          closeLFDocNav(headingLFDoc);
        } else {
          openLFDocNav(headingLFDoc);
        }
      });
    }

    closeLFDocNav(headingLFDoc);
  } else {
    // disable / remove section nav toggle
    headingLFDoc.removeClass("open").next("ul.nav").show();
    $("#lf-doc-nav ul.nav > li > a").off(".openNav");
    headingLFDoc.children("button").off("click");
    headingLFDoc
      .children("button")
      .attr("aria-expanded", "true")
      .contents()
      .unwrap();
  }
}

function openLFDocNav(headingLFDoc) {
  headingLFDoc.next("ul.nav").show();
  headingLFDoc.addClass("open");
  headingLFDoc.children("button").attr("aria-expanded", "true");

  $("#lf-doc-nav .lf-nav__link").on("click.openNav", function (e) {
    closeLFDocNav(headingLFDoc);
  });
}

function closeLFDocNav(headingLFDoc) {
  headingLFDoc.next("ul.nav").hide();
  headingLFDoc.removeClass("open");
  headingLFDoc.children("button").attr("aria-expanded", "false");

  $("#lf-doc-nav .lf-nav__link").off(".openNav");
}
